export type LanguageType = "ko" | "en" | "zh-TW";

export const languageMap = {
  ko: "ko",
  en: "en",
  "zh-TW": "zh-TW",
};

export const localeLabels: Record<LanguageType, string> = {
  ko: "한국어",
  en: "English",
  "zh-TW": "繁體中文",
};
